import React from 'react';
import { Container, Row, Col, Form, Button } from 'react-bootstrap';
import { useLanguage } from './LanguageContext';
import translations from '../translations.json';
import './Contact.css';

const Contact: React.FC = () => {
  const { language } = useLanguage();
  const t = translations[language]['contact'];

  return (
    <section className="contact vh-100 d-flex flex-column justify-content-center" id="contact">
      <Container>
        <Row className="align-items-start">
          <Col md={6} className="contact-info px-5">
            <h2 className="contact-title" dangerouslySetInnerHTML={{ __html: t.title }} />
            <p className="contact-description mt-5">{t.description}</p>
            <div className="mt-5">
              <div>
                <img src="/img/icon/PhoneIcon.png" alt="Phone Icon"/>
                <span className="contact-text text-red fs-3">{t.phone}</span>
              </div>
              <div className="contact-item my-5">
                <img src="/img/icon/MailIcon.png" alt="Mail Icon" />
                <span className="contact-text text-red fs-3">{t.email}</span>
              </div>
            </div>
          </Col>
          <Col md={6} className="contact-form d-flex flex-column align-items-center mx-auto">
            <Form className="d-flex flex-column align-items-center">
              <Form.Group controlId="formName">
                <Form.Control type="text" placeholder={t.form.name} />
              </Form.Group>
              <Form.Group controlId="formCompanyName">
                <Form.Control type="text" placeholder={t.form.company} />
              </Form.Group>
              <Form.Group controlId="formPhoneNumber">
                <Form.Control type="tel" placeholder={t.form.phone} />
              </Form.Group>
              <Form.Group controlId="formEmail">
                <Form.Control type="email" placeholder={t.form.email} />
              </Form.Group>
              <Form.Group controlId="formMessage">
                <Form.Control as="textarea" rows={4} placeholder={t.form.message} style={{ height: '194px', resize: 'none' }} />
              </Form.Group>
              <Button variant="btn btn-red" className="submit-btn mx-auto" type="submit">
                {t.form.submit}
              </Button>
            </Form>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Contact;
